export const getFrontDomain = () =>
  process.env.REACT_APP_FRONT_DOMAIN ||
  'https://test.d3c7spy4c3mn0o.amplifyapp.com/';
